import React from 'react';
import { X } from 'lucide-react';

const LEGAL_DOCS = {
  privacy: { title: 'Privacy Policy', src: '/privacy.html' },
  terms: { title: 'Terms of Service', src: '/terms.html' }
};

const LegalDocModal = ({ doc, onClose }) => {
  if (!doc) return null;
  const { title, src } = LEGAL_DOCS[doc];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl h-full max-h-[90vh] flex flex-col overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 flex-shrink-0">
          <h2 className="text-lg font-bold text-gray-900">{title}</h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="p-2 text-gray-500 hover:text-white hover:bg-red-500 rounded-lg transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        <iframe
          src={src}
          title={title}
          className="flex-1 w-full"
          style={{ border: 'none' }}
        />
        <div className="flex justify-end px-4 py-3 border-t border-gray-200 flex-shrink-0">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium"
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalDocModal;
